// src/components/ui/InlineLoader.jsx
import PropTypes from 'prop-types'
import { RefreshCw } from 'lucide-react'
import { cn } from '../../utils/cn'

const InlineLoader = ({ 
  title = 'Loading...', 
  className = '',
  size = 'sm',
  showIcon = true,
  py = 'py-8'
}) => {
  const sizeClasses = {
    xs: 'h-4 w-4',
    sm: 'h-6 w-6',
    md: 'h-8 w-8', 
    lg: 'h-8 w-8'
  }

  return (
    <div className={cn("flex items-center justify-center", py, className)}>
      {showIcon && (
        <RefreshCw className={cn(
          "animate-spin text-orange-500",
          sizeClasses[size],
          title && "mr-2"
        )} />
      )}
      {title && (
        <span className="text-gray-600">{title}</span>
      )}
    </div>
  )
}

InlineLoader.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  showIcon: PropTypes.bool,
  py: PropTypes.string
}

export default InlineLoader
